import React, { useState } from "react";

// Importing the images
import Tab1Image from "../img/envision/utilites/cards/utiliti1.jpg";
import Tab2Image from "../img/envision/utilites/cards/utiliti2.jpg";
import Tab3Image from "../img/envision/utilites/cards/utiliti4.jpg";
import Tab4Image from "../img/envision/utilites/cards/utiliti5.jpg";
import Tab5Image from "../img/envision/utilites/cards/utiliti1.jpg";
import Tab6Image from "../img/envision/energy/cards/energy6.jpg";

// Importing Font Awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCar, 
    faTruck, 
    faMotorcycle, 
    faCogs, 
    faGear, 
    faSlidersH, 
    faGlobe,
    faMicrochip, 
    faWrench, 
    faScrewdriver, 
    faBattery, 
    faBolt, 
    faWifi, 
    faDatabase,
    faCloud, 
    faNetworkWired, 
    faDesktop, 
    faLaptop, 
    faTablet, 
    faVial,   // Added faVial for testing
    faLaptopCode, // Added faLaptopCode for Digital Technology
  } from "@fortawesome/free-solid-svg-icons";
const Utilitiesverticaltabs = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      display: "flex",
      width: "80%",
      margin: "50px auto",
    },
    tabNav: {
      display: "flex",
      flexDirection: "column",
      width: "200px",
      borderRight: "2px solid #fff",
    },
    tabButton: {
      padding: "20px 20px",
      cursor: "pointer",
      border: "none",
      background: "none",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#555",
      outline: "none",
      transition: "color 0.3s, background-color 0.3s",
      borderRadius: "23px",
      margin: "5px 0",
      backgroundColor: "#f0f0f0",
    },
    activeTabButton: {
      backgroundColor: "#009ca5",
      color: "#fff",
    },
    tabContent: {
      padding: "0px",
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      backgroundSize: "cover",
      backgroundPosition: "center",
      // backgroundAttachment: "fixed",
      borderRadius: "23px",
      height: "430px",
      color: "#fff",
      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
    },
    contentBox: {
      backgroundColor: "rgb(0 156 165)",
      padding: "20px",
      borderRadius: "20px",
      width: "100%",
      textAlign: "center",
    },
    icon: {
      marginRight: "10px",
      color: "#fff",
      fontSize: "24px",
    },
  };

  const getTabBackgroundImage = () => {
    switch (activeTab) {
      case "tab1":
        return `url(${Tab1Image})`;
      case "tab2":
        return `url(${Tab3Image})`;
      case "tab3":
        return `url(${Tab2Image})`;
      case "tab4":
        return `url(${Tab4Image})`;
      case "tab5":
        return `url(${Tab5Image})`;
    //   case "tab6":
    //     return `url(${Tab6Image})`;
      default:
        return "none";
    }
  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>
        <span style={{ color: "rgb(5 133 158)" }}>Our Expertise in</span> Automotive Solutions
      </h1>
      <div style={styles.container}>
        <div style={styles.tabNav}>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab1" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab1")}
          >
         Electric Utilities
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab2" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab2")}
          >
           Gas Utilities
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab3" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab3")}
          >
      Water Utilities
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab4" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab4")}
          >
          Design
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab5" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab5")}
          >
          Build
          </button>
          {/* <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab6" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab6")}
          >
           Operations & Maintenance
          </button> */}
        </div>

        <div style={{ ...styles.tabContent, backgroundImage: getTabBackgroundImage() }}>
          <div style={styles.contentBox}>
            {activeTab === "tab1" && (
              <p>
                <FontAwesomeIcon icon={faCar} style={styles.icon} />
                <FontAwesomeIcon icon={faTruck} style={styles.icon} />
                <FontAwesomeIcon icon={faGear} style={styles.icon} />
                <br></br>
                Electric Utilities
              </p>
            )}
            {activeTab === "tab2" && (
              <p>
                <FontAwesomeIcon icon={faMicrochip} style={styles.icon} />
                <FontAwesomeIcon icon={faSlidersH} style={styles.icon} />
                <FontAwesomeIcon icon={faWifi} style={styles.icon} />

                <br></br>
                Gas Utilities
              </p>
            )}
            {activeTab === "tab3" && (
              <p>
                <FontAwesomeIcon icon={faCogs} style={styles.icon} />
                <FontAwesomeIcon icon={faCloud} style={styles.icon} />
                <FontAwesomeIcon icon={faWifi} style={styles.icon} /><br></br>
                Water Utilities
              </p>
            )}
            {activeTab === "tab4" && (
              <p>
                <FontAwesomeIcon icon={faVial} style={styles.icon} />
                <FontAwesomeIcon icon={faTablet} style={styles.icon} />
                <FontAwesomeIcon icon={faWifi} style={styles.icon} /><br></br>
                Design
              </p>
            )}
            {activeTab === "tab5" && (
              <p>
                <FontAwesomeIcon icon={faNetworkWired} style={styles.icon} />
                <FontAwesomeIcon icon={faDesktop} style={styles.icon} />
                <FontAwesomeIcon icon={faLaptop} style={styles.icon} /><br></br>
                Build
              </p>
            )}
            {/* {activeTab === "tab6" && (
              <p>
                <FontAwesomeIcon icon={faLaptopCode} style={styles.icon} />
                <FontAwesomeIcon icon={faDatabase} style={styles.icon} />
                <FontAwesomeIcon icon={faGlobe} style={styles.icon} /><br></br>
                Digital Excellence
              </p>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Utilitiesverticaltabs;
